import { useState, useEffect } from "react";
import { getCurrentMinutes } from "../utils/timeUtils";

export const useCurrentTime = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [currentTimeMinutes, setCurrentTimeMinutes] = useState(getCurrentMinutes());

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      setCurrentTime(now);
      setCurrentTimeMinutes(getCurrentMinutes());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return { currentTime, currentTimeMinutes };
};
